import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

export default function api() {

    // const baseUrl = 'http://localhost:3001'
    const baseUrl = 'https://wwyb-api.onrender.com'

    return {
        login: async (email, password) => {
            return axios.post(`${baseUrl}/auth/login`, {
                email: email,
                password: password
            })
        },
        loginWithGoogle: async (idToken) => {
            return axios.post(`${baseUrl}/auth/google`, {
                idToken: idToken
            })
        },
        signup: async (data) => {
            return axios.post(`${baseUrl}/register/email`, {
                firstName: data.firstName,
                lastName: data.lastName,
                username: data.username,
                email: data.email,
                password: data.password,
                birthMonth: data.birthMonth,
                birthDay: data.birthDay,
                isPrivate: data.isPrivate
            })
        },
        getCode: async (data) => {
            return axios.post(`${baseUrl}/auth/create-code`, {
                email: data.email,
            })
        },
        postCode: async (data) => {
            return axios.post(`${baseUrl}/auth/post-code`, {
                email: data.email,
                code: data.code
            })
        },
        getMe: async (authToken) => {
            return axios.get(`${baseUrl}/users/me`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        updateMe: async (authToken, data) => {
            return axios.post(`${baseUrl}/users/me/update`, data, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },

        updateBirthday: async (authToken, data) => {
            return axios.post(`${baseUrl}/users/me/update-birthday`, data, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        
        getMarketingPrefs: async (authToken) => {
            return axios.get(`${baseUrl}/marketing/me`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        updateMarketingPrefs: async (authToken, data) => {
            return axios.post(`${baseUrl}/marketing/me`, data, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        listBirthdaysForMonth: async (authToken) => {
            return axios.get(`${baseUrl}/birthday/list  `, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        searchUsers: async (authToken, query) => {
            return axios.get(`${baseUrl}/users/search?query=${query}`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        getUser: async (authToken, username) => {
            return axios.get(`${baseUrl}/users/${username}`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        sendFollowRequest: async (authToken, userId) => {
            return axios.post(`${baseUrl}/follow/create`, {
                other: userId
            }, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        unfollow: async (authToken, userId) => {
            return axios.post(`${baseUrl}/follow/remove`, {
                other: userId
            }, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        fetchNotifications: async (authToken) => {
            return axios.get(`${baseUrl}/notifications/list`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        markNotificationsAsRead: async (authToken, ids) => {
            return axios.post(`${baseUrl}/notifications/read?id=${ids}`, {}, {
                headers: {
                    'x-access-token': authToken
                }
            });
        },
        listWhoIFollow: async (authToken) => {
            return axios.get(`${baseUrl}/follow/me`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        listMyFollowers: async (authToken) => {
            return axios.get(`${baseUrl}/follow/mine`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        listFollowingForUser: async (authToken, userId) => {
            return axios.get(`${baseUrl}/follow/${userId}/following`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        listFollowersForUser: async (authToken, userId) => {
            return axios.get(`${baseUrl}/follow/${userId}/followers`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },

        // their relationship to us
        listFollowFromUser: async (authToken, userId) => {
            return axios.get(`${baseUrl}/follow/status/${userId}`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        listMyPendingFollows: async (authToken) => {
            return axios.get(`${baseUrl}/follow/pending`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        performFollowAction: async (authToken, id, action) => {
            return axios.post(`${baseUrl}/follow/${id}/${action}`, {}, {
                headers: {
                    'x-access-token': authToken
                }
            });
        },

        getUserCount: async () => {
            return axios.get(`${baseUrl}/info/count`)
        },

        getFollowRecs: async (authToken) => {
            return axios.get(`${baseUrl}/follow/recs`, {
                headers: {
                    'x-access-token': authToken
                }
            })
        },
        createCustomBirthday: async (authToken, data) => {
            return axios.post(`${baseUrl}/birthday/custom`, data, {
                headers: {
                    'x-access-token': authToken
                }
            });
        },

        requestForgotPasswordLink: async (data) => {
            return axios.post(`${baseUrl}/auth/forgot`, data);
        },

        resetPassword: async (data) => {
            return axios.post(`${baseUrl}/auth/reset`, data);
        }
    }
}
